/**
 * Gets a server supplied download name from Content-Disposition.
 *
 * ASP.NET Core supplies an ASCII filename fallback as well as an RFC 8187
 * filename* parameter for names containing non-ASCII characters. The latter
 * contains the actual UTF-8 name and must take precedence.
 */
export function getDownloadFileName(contentDisposition: string | null, defaultName: string): string {
  const encodedFileName = getDispositionParameter(contentDisposition, 'filename*');
  const decodedFileName = encodedFileName && decodeUtf8FileName(encodedFileName);

  return decodedFileName || getDispositionParameter(contentDisposition, 'filename') || defaultName;
}

function getDispositionParameter(contentDisposition: string | null, parameterName: string): string | undefined {
  if (!contentDisposition) {
    return undefined;
  }

  const escapedParameterName = parameterName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parameterExpression = new RegExp(`(?:^|;)\\s*${escapedParameterName}\\s*=\\s*(?:\"((?:\\\\.|[^\"])*)\"|([^;]*))`, 'i');
  const match = parameterExpression.exec(contentDisposition);
  const value = match?.[1] ?? match?.[2]?.trim();

  return value?.replace(/\\(.)/g, '$1');
}

function decodeUtf8FileName(value: string): string | undefined {
  const match = /^([^']*)'[^']*'(.*)$/.exec(value);
  if (!match || !/^utf-8$/i.test(match[1])) {
    return undefined;
  }

  try {
    return decodeURIComponent(match[2]);
  } catch {
    return undefined;
  }
}
